import Vue from 'vue'
import { i18n } from './../api/i18n'
var v = new Vue()
export default async function confirmBox (msg, confirmButtonText, cancelButtonText, closeOnClickModal=true) {
  let result = false
  await new Promise(
    function (resolve, reject) {
      v.$confirm.confirm(msg, i18n.t('hint'), {
        confirmButtonText: confirmButtonText || i18n.t('confirm'),
        cancelButtonText: cancelButtonText || i18n.t('cancel'),
        type: 'warning',
        closeOnClickModal
      }).then(() => {
        result = true
        resolve()
      }).catch(() => {
        resolve()
      })
    })
  return result
}
export async function confirmBoxUseHtml (msg) {
  return new Promise(
    function (resolve, reject) {
      v.$confirm.confirm(msg, i18n.t('hint'), {
        confirmButtonText: i18n.t('confirm'),
        cancelButtonText: i18n.t('cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        resolve(true)
      }).catch(() => {
        resolve(false)
      })
    })
}

export async function confirmCustomBox (msg, subMsg, confirmButtonText, cancelButtonText, closeOnClickModal=true) {
  let result = false
  await new Promise(
    function (resolve, reject) {
      const h = v.$createElement
      v.$confirm.confirm('', {
        message: h('div', null, [
          h('span', {}, ''),
          h('p', {}, msg),
          h('p', {
            style: {
              fontSize: '14px',
              color: '#868D9F'
            },
          }, subMsg)
        ]),
        confirmButtonText: confirmButtonText || i18n.t('confirm'),
        cancelButtonText: cancelButtonText || i18n.t('cancel'),
        type: 'warning',
        closeOnClickModal,
        customClass: 'custom-confirm-box ',
        cancelButtonClass: 'custom-cancel-button',
        confirmButtonClass: 'custom-confirm-button'
      }).then(() => {
        result = true
        resolve()
      }).catch(() => {
        resolve()
      })
    })
  return result
}